import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Edit from "../../../assets/icon/NewsIcons/MainAdmin/NewsEdit"
import Block from "../../../assets/icon/NewsIcons/MainAdmin/NewsBlock"
import Delete from "../../../assets/icon/NewsIcons/MainAdmin/NewsDelete"
import Detail from "../../../assets/icon/NewsIcons/MainAdmin/NewsDetail"
import { ReactComponent as Right } from "../../../assets/icon/right.svg";
import { ReactComponent as Left } from "../../../assets/icon/left.svg";
const FieldTables = ({ detail, setting, edit, block, deleted, titleRow, writersList, setShowSettingModal, setShowEditModal,
    setShowBlockModal, setShowDeleteModal, setData, type,count, page, setPage, row, setRow }) => {


    let navigate = useNavigate()

    return (
        <div className="rounded-[15px] pt-[15px] px-[15px] pb-[120px] border-borderGray border-2 w-full overflow-auto">
            <table className="w-full">
                {
                    titleRow ?
                        <tr className="h-[60px] w-full bg-lightBlue2">
                            <th className="rounded-r-[15px] text-right pr-[17px] text-[15px] font-IRANYekanBold text-mainColor2">ردیف</th>
                            <th className="text-[15px] text-right font-IRANYekanBold text-mainColor2">{titleRow[0]}</th>

                            {/* <th className="text-[15px] text-right font-IRANYekanBold text-mainColor2">{titleRow[5]}</th> */}
                            <th className="rounded-l-[15px] text-center pl-[17px] text-[15px] font-IRANYekanBold text-mainColor2">عملیات</th>
                        </tr>
                        :
                        null
                }
                {
                    writersList?.length > 0 ?
                        writersList?.map((item, index) => {
                            return (
                                <tr className="h-[56px] w-full border-b-2 border-borderGray">
                                    <th className="text-[15px] text-right pr-[17px] font-IRANYekanBold">{ index + 1 + ((page - 1) * row)}</th>

                                    <th className="text-[15px] text-right font-IRANYekanBold">{ item?.name}</th>

                                    <th><div className="flex pl-[17px] justify-center items-center">
                                        {detail == true ?
                                            <button onClick={() => navigate("/mainAdmin/collegeFields",{state:{id:item?.collegeId}})} className="ml-[11px]"><Detail /></button>
                                            : null}
                                      
                                        {edit == true ?
                                            <button onClick={() => { setShowEditModal(true); setData(item) }} className="ml-[11px]"><Edit /></button>
                                            : null}
                                        {block == true ?
                                            <button onClick={() => { setShowBlockModal(true); setData(item) }} className="ml-[11px]"><Block /></button>
                                            : null}
                                        {deleted == true ?
                                            <button onClick={() => { setShowDeleteModal(true); setData(item) }} ><Delete /></button>
                                            : null}
                                    </div></th>
                                </tr>
                            )
                        })
                        :
                        null}


            </table>
            <div className="  w-full py-3 px-3">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center">
                            <p className="text-sm text-right px-4 font-IRANYekanMedium">
                                تعداد ردیف در هر صفحه :
                            </p>
                            <div className="flex flex-col w-[80px] ml-20 font-IRANYekanMedium">
                                <div class=" ">

                                    <select
                                        name="rowNumber"
                                        id="rowNumber"
                                        onChange={(e) => { setRow(e.target.value); setPage(1) }}
                                        className="   text-right  bg-white border border-gray-300 text-gray-900 text-sm rounded-md  focus:ring-mainColor focus:border-mainColor block w-full px-2 py-1">
                                        <option value="5" className=" ">۵ </option>
                                        <option value="10" selected className=" ">۱۰</option>
                                        <option value="25" className=" ">۲۵</option>


                                    </select>
                                    {/* <input
                              type="text"
                              id="input-group-1"
                              disabled="true"
                              class="pr-9   text-right right-6 bg-white border border-gray-300 text-gray-900 text-sm rounded-md  focus:ring-mainColor focus:border-mainColor block w-full pl-10 p-2.5  "
                              placeholder="آرمان"/> */}
                                </div>
                            </div>
                        </div>
                        <div className="flex items-center font-IRANYekanMedium">
                            
                            <p className="text-sm text-right pr-4 mx-2">
                                {((page - 1) * row) + 1}-{count < row * page ? count : row * page} از {count}
                            </p>
                            <div className="flex mr-2">
                                <button onClick={() => setPage(page + 1)} disabled={count <= row * page} className="mx-2">
                                    <Right />
                                </button>
                                <button onClick={() => setPage(page - 1)} disabled={page == 1 ? true : false} className="mx-2">
                                    <Left />
                                </button>
                            </div>
                        </div>
                    </div>

                </div>


        </div>
    )
}

export default FieldTables;